import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import "../css/Home.css";
import "../css/Theme.css";
import CustomizedAlert from "../components/CustomizedAlert";
import AcceptCookie from "../components/AcceptCookie";
import { ThemeProvider } from '@mui/material/styles';
import { m2dTheme } from "../theme";
import { updateRole } from "../redux/actions";
import Page from "../../../common/Page";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";

function Home(props) {

  // const [message, setMessage] = useState("");
  // const [messageOpen, setMessageOpen] = useState(false)
  // useEffect(() => {
  //   // Create WebSocket connection
  //   const socket = new WebSocket("ws:/localhost:8081");

  //   // socket.binaryType = "text"

  //   socket.onopen = () => {
  //     socket.send(JSON.stringify(user.Id))
  //   }

  //   socket.onmessage = (e) => {
  //     // console.log(e.data)
  //     setMessage(e.data)
  //     setMessageOpen(true)
  //   }

  //   return () => {
  //     // Close WebSocket connection
  //     socket.close();
  //   };
  // }, [props])

  // const handleNotification = () => {
  //   setMessageOpen(false)
  //   // TODO: navigate to the message
  // }

  // const handleMessageClose = () => {
  //   setMessageOpen(false)
  // }

  const { user, alertType, alertMessage, alertOpen, role, handleRole } = props

  const navigate = useNavigate()

  useEffect(() => {
    if (!role) {
      const feature = Object.values(user.featureUsers).find(f => f.app === "m2d")
      console.log(feature)
      if (feature) {
        handleRole(feature.role)
      } else {
        navigate("/")
      }
    }
  }, [user, navigate, handleRole, role]);


  return (
    <Page title="M²D" style={{backgroundColor: 'white'}}>
      <div className="background"></div>
      <div className={`alert${alertOpen ? "" : "-closed"}`}>
        <CustomizedAlert
          alertType={alertType}
          alertMessage={alertMessage}
        />
      </div>
      <div className="home">
        {/* <div className="side-bar">
          <Sidebar />
        </div> */}
        <div className="main-page">
          <div className="topbar">
            <Topbar />
          </div>

          <div className="outlet">
            <div className="home-white-space"> </div>
            <ThemeProvider theme={m2dTheme}>
              <Outlet />
            </ThemeProvider>
            <div className="home-white-space-footer"> </div>
          </div>
          <div className="footer">
            <Footer />
          </div>
        </div>
        <AcceptCookie />
      </div>
      {/* <div className={`notification${messageOpen ? "" : "-closed"}`} onClick={handleNotification}>
        <div className="top">
          <div className="n-title">Notification</div>
          <div className="close-note-btn" onClick={handleMessageClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="text">
          {message}
        </div>
      </div> */}
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    alertType: state.m2d.alertType,
    alertMessage: state.m2d.alertMessage,
    alertOpen: parseInt(state.m2d.alertOpen),
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleRole(role) {
      updateRole(role)(dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
